const handleInputMixin = {
  methods: {
    handleInput(property, value) {
      const payload = {};
      payload[property] = value;
      this.$emit('input', payload);
    }
  }
};

export default handleInputMixin;
